<template>
  <section class="elementor-section elementor-top-section elementor-element elementor-element-8339169 elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="8339169" data-element_type="section" data-e-type="section" data-settings="{&quot;background_background&quot;:&quot;gradient&quot;}">
    <div  class="elementor-container- elementor-container-slogan elementor-column-gap-no">
      <!-- <div class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-1397ddc elementor-hidden-mobile" data-id="1397ddc" data-element_type="column" data-e-type="column">
        <div class="elementor-widget-wrap"></div>
      </div> -->
      <div class="elementor-column slogan elementor-col-50 elementor-top-column elementor-element elementor-element-2fb40d7" data-id="2fb40d7" data-element_type="column" data-e-type="column" data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
        <div class="elementor-widget-wrap elementor-element-populated">
          <div class="elementor-element elementor-element-5b191cc elementor-widget__width-auto elementor-widget elementor-widget-heading" data-id="5b191cc" data-element_type="widget" data-e-type="widget" data-widget_type="heading.default">
            <div class="elementor-widget-container">
              <h3 class="elementor-heading-title elementor-size-default slogan">{{ settings.slogan }}</h3>
            </div>
          </div>
          <div class="vamtam-has-theme-widget-styles elementor-element elementor-element-6c28eaf vamtam-has-underline-anim elementor-widget elementor-widget-button" data-id="6c28eaf" data-element_type="widget" data-e-type="widget" data-widget_type="button.default">
            <div class="elementor-widget-container">
              <div class="elementor-button-wrapper">
                <a class="elementor-button elementor-button-link elementor-size-sm" :href="settings.url_btn_slogan">
                  <span class="elementor-button-content-wrapper">
                    <span class="elementor-button-text">{{ settings.title_button_slogan }}</span>
                  </span>
                </a>
              </div>
            </div>
          </div>
          <div class="elementor-element elementor-element-4b4b287 elementor-widget__width-auto elementor-absolute elementor-widget-divider--view-line elementor-widget elementor-widget-divider" data-id="4b4b287" data-element_type="widget" data-e-type="widget" data-settings="{&quot;_position&quot;:&quot;absolute&quot;}" data-widget_type="divider.default">
            <div class="elementor-widget-container">
              <div class="elementor-divider">
                <span class="elementor-divider-separator"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>

  const settings = {
    "slogan": "Commited to Better Life",
    "title_button_slogan": "Contact us",
    "url_btn_slogan": "/contact"
  };
  export default {
    name: 'SloganSectionComponent',
    data() {
      return{
        settings: settings,
      }
    },
  }
</script>
<style>
  .elementor-kit-5 {
    --e-global-color-vamtam_accent_5_slogan: #4F8F76;
  }
</style>

<style scoped>
  .elementor-1905 .elementor-element.elementor-element-2fb40d7 > .elementor-element-populated {
    /* padding-inline-start: 40px; */
    padding-block-end: 48px;
  }

  .elementor-1905 .elementor-element.elementor-element-5b191cc {
    width: 100%;
  }

  .elementor-1905 .elementor-element.elementor-element-8339169:not(.elementor-motion-effects-element-type-background), .elementor-1905 .elementor-element.elementor-element-8339169 > .elementor-motion-effects-container > .elementor-motion-effects-layer {
    background-image: none;
  }
  
  .elementor-1905 .slogan.elementor-element.elementor-element-2fb40d7:not(.elementor-motion-effects-element-type-background) > .elementor-widget-wrap, .elementor-1905 .elementor-element.elementor-element-2fb40d7 > .elementor-widget-wrap > .elementor-motion-effects-container > .elementor-motion-effects-layer {
    background-color: var(--e-global-color-vamtam_accent_5_slogan);
  }

  .elementor-kit-5 h3.slogan {
    color: #fff;
  }

  .elementor-1905 .elementor-element.elementor-element-6c28eaf .elementor-button {
    background: #fff;
    border-radius: 6px;
    padding: 5px 10px;
    color: #000;
  }

  .elementor-1905 .elementor-container-slogan {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
</style>